export {
    HousePricesResults as default,
    getServerSideProps
} from '@zoopla/house-prices/results';
